import { render, staticRenderFns } from "./writeNewPost.vue?vue&type=template&id=e2811162&"
import script from "./writeNewPost.vue?vue&type=script&lang=js&"
export * from "./writeNewPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports